/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

import { SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure
} from "@chakra-ui/react";
import axios from "axios";

import debounce from "lodash/debounce";
import { getTheme } from "src/styles/theme";
import SearchBar from "./SearchBar";
import SearchResults from "./SearchResults";

const chakraTheme = getTheme();


interface SearchResultsProps {
  //client: ContentfulClient;
  query: string;
  pageTypes: string;
}

// Create the search modal component
function SearchModal() {
  // Use the useDisclosure hook from Chakra UI to manage the modal's open/close state
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Create a ref for the search input field
  const searchInputRef = React.useRef();

  const [query, setQuery] = React.useState<string>("");
  const [pageTypes, setPageTypes] = React.useState<string>("pages,posts");

  const [results, setResults] = useState<any[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isPageInitialized, setIsPageInitialized] = useState<boolean>(false);
  const router = useRouter();

  const onCloseModal = () => {
    console.log('onCloseModal');
    setQuery("");
    setResults([]);
    onClose();
    console.log('onCloseModal2');
  };

  const fetchResults = async ({ query, pageTypes }: any) => {
    const search = `/api/search?q=${query}&page_types=${pageTypes}`;
    setIsFetching(true);
    axios
      .get(search)
      .then((data) => {
        setResults(data.data);
        // change history for Google Analytics
        if (query && query.length >= 3) {
          const q = { ...router.query, s: query };
          router.replace({
             pathname: router.pathname,
            query: q,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const debounceOnChange = React.useCallback(debounce(fetchResults, 1000), [
    query,
    pageTypes,
  ]);

  useEffect(() => {
    if (query && query.length >= 3 && isPageInitialized) {
      debounceOnChange({ query, pageTypes });
    } else if (query.length >= 3) {
      fetchResults({ query, pageTypes });
    } else if (router.query.s && !isPageInitialized) {
      setIsPageInitialized(true);
      setQuery(router.query.s as string);
      onOpen();
    }
  }, [query, pageTypes, router.query.s]);



  if (typeof window !== "undefined") {
    // needed if SSR
    (window as any).openSearchModal = () => {
      onOpen();
      // set state, what ever you need
    };
  }

  return (
    <>
      {/* Render a button that opens the modal when clicked */}
      <Button
        aria-label="Search Senior Healthcare Direct"
        variant="menu-bar-button"
        onClick={onOpen}
        position="absolute"
        right={[0, 0, 2]}
        zIndex={100}
        rightIcon={<SearchIcon />}
      >
        Search
      </Button>

      {/* Render the modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px) " />
        <ModalContent>
          <ModalHeader>
            <Heading as="h1">Site Search</Heading>
          </ModalHeader>
          <ModalCloseButton border="none" style={{ cursor: "pointer" }} />

          <ModalBody>
            <Box>
              {/* Use the InstantSearch component from react-instantsearch-dom to perform search queries */}
              {/* Use the Configure component to specify which attributes to search and how to sort the results */}

              {/* Use the SearchBox component from react-instantsearch-dom to render a search input field */}
              <SearchBar
                refine={setQuery}
                currentRefinement={query}
                setPageTypes={setPageTypes}
                isFetching={isFetching}
              />

              {/* Use the Hits component from react-instantsearch-dom to render the search results */}
              <Box
                bg="#f1f1f1"
                borderRadius={15}
                overflow={"auto"}
                maxHeight={500}
                border="1px solid #ccc"
              >
                <SearchResults results={results} query={query} onCloseModal={onCloseModal} />
              </Box>
            </Box>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default React.memo(SearchModal);
